import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import ClientReclamation from "./component/forms/ClientReclamation.jsx";
import CharteGarantie from "./component/forms/CharteGarantie.jsx";
import ContactForm from "./component/forms/ContactForm.jsx";
import SAVForm from "./component/forms/sav/SAVForm.jsx";

const Routes = () => {
  return (
    <Router>
      <Switch>
        <Route
          path="/:locale/reclamation-client"
          component={ClientReclamation}
        />
        <Route path="/:locale/sav" component={SAVForm} />
        <Route
          path="/:locale/lifetimerepairwarranty"
          component={CharteGarantie}
        />
        <Route path="/:locale/contact" component={ContactForm} />
      </Switch>
    </Router>
  );
};

export default Routes;
